/**
 * Full-width marquee ticker between Hero and Features.
 * Pure CSS infinite scroll; respects prefers-reduced-motion.
 */
import { useTranslation } from "react-i18next";

const ITEMS_KEY = [
  "ticker.sources",
  "ticker.reliability",
  "ticker.trial",
  "ticker.gdpr",
  "ticker.eu",
  "ticker.areas",
  "ticker.templates",
  "ticker.aiAct",
] as const;

export function SocialProofTicker() {
  const { t } = useTranslation();
  const items = ITEMS_KEY.map((k) => t(k, { defaultValue: defaultFor(k) }));
  // Duplicate the row so the marquee loop is seamless.
  const row = [...items, ...items];
  return (
    <section
      aria-label="Social proof"
      className="relative overflow-hidden border-y border-border bg-foreground text-background"
    >
      <div className="ticker-track flex min-w-max gap-10 py-3.5 px-5 text-[11px] font-bold uppercase tracking-[0.12em] sm:gap-16 sm:py-4 sm:px-6 sm:text-[12px]">
        {row.map((label, i) => (
          <span key={i} className="inline-flex items-center gap-3 whitespace-nowrap">
            <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-teal-400" />
            {label}
          </span>
        ))}
      </div>

      <style>{`
        .ticker-track { animation: ticker 40s linear infinite; }
        @media (prefers-reduced-motion: reduce) {
          .ticker-track { animation: none; }
        }
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}

function defaultFor(k: string): string {
  switch (k) {
    case "ticker.sources": return "5M+ fonti consultabili";
    case "ticker.reliability": return "98% affidabilità citazioni";
    case "ticker.trial": return "14 giorni prova gratuita";
    case "ticker.gdpr": return "GDPR Compliant";
    case "ticker.eu": return "Dati in EU";
    case "ticker.areas": return "10 aree legali coperte";
    case "ticker.templates": return "40+ template professionali";
    case "ticker.aiAct": return "AI Act EU Compliant";
    default: return "";
  }
}
